var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0.96875C22.0625 0.96875 0.96875 22.0625 0.96875 48C0.96875 73.9375 22.0625 95.0312 48 95.0312C73.9375 95.0312 95.0312 73.9375 95.0312 48C95.0312 22.0625 73.9375 0.96875 48 0.96875ZM48 17.8438C55.5 17.8438 61.75 23.9375 61.75 31.5938C61.75 39.0938 55.6562 45.3438 48 45.3438C40.5 45.3438 34.25 39.25 34.25 31.5938C34.4062 24.0938 40.5 17.8438 48 17.8438ZM72.8438 76.75H23.1563C22.375 76.75 21.5938 76.125 21.5938 75.1875C21.5938 60.6562 33.4688 48.7812 48 48.7812C62.5312 48.7812 74.4062 60.6562 74.4062 75.1875C74.4062 76.125 73.7812 76.75 72.8438 76.75Z",
    fill: "#FFFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.0c70bcff1e4bf5f81d47e64a2af61707.svg";
export { ForwardRef as ReactComponent };